import { createSelector } from 'reselect'
import { Firebase } from '../../Core'

import { getPlayerData } from '../../Core/Firebase/firebase.selectors'
import { getCountersData } from '../Indicators/indicators.selectors'

import * as utils from './quizzes.utils'

export const getQuizzes = (state) => state.mars.quizzes

export const isSavedOk = createSelector([getQuizzes], (quizzes) => quizzes.saveOk)
export const isSavedError = createSelector([getQuizzes], (quizzes) => {
  return quizzes.saveError
})
export const getCurrentQuestion = createSelector([getQuizzes], (quizzes) => {
  return quizzes.question
})
export const getVoteQuestion = createSelector([getQuizzes], (quizzes) => {
  return quizzes.voteQuestion
})

export const getFeedBack = createSelector([getQuizzes], (quizzes) => {
  return quizzes.feedBack
})

export const getLoading = createSelector([getQuizzes], (quizzes) => {
  return quizzes.loading
})

export const getDisputesList = createSelector([getQuizzes], (quizzes) => {
  return quizzes.disputesList
})
export const getQuestionList = createSelector([getQuizzes], (quizzes) => {
  return quizzes.questionsList
})

export const getDisputesListFilter = createSelector([getQuizzes], (quizzes) => {
  return quizzes.disputesListFilter
})

export const getRankingSearch = createSelector([getQuizzes], (quizzes) => quizzes.search)

export const getFilteredDisputesList = createSelector(
  [getDisputesList, getDisputesListFilter, getRankingSearch, Firebase.selectors.getUserData],
  (questions, filter, search, userData) => {
    const newQuestions = questions
    return utils.getFilteredQuestions(newQuestions, filter, userData, search)
  }
)

export const isAnswerPenalized = createSelector(
  [getCountersData],
  ({ an_pen, an_t }) => an_t !== 0 && an_t <= an_pen
)

export const isCreatePenalized = createSelector(
  [getCountersData],
  ({ qu_pen, qu_t }) => qu_t !== 0 && qu_t <= qu_pen
)

const turnPrizes = { 1: 2, 2: 4, 3: 4, 4: 8, 5: 8, 6: 16 }

export const getAnswerPrizeCoins = createSelector(
  [getPlayerData, isAnswerPenalized],
  ({ turn }, isAnswerPenalized) => {
    return isAnswerPenalized ? 1 : turn <= 6 ? turnPrizes[turn] : 16
  }
)

export const getCreatePrizeCoins = createSelector(
  [getPlayerData, isCreatePenalized],
  ({ turn }, isCreatePenalized) => {
    return isCreatePenalized ? 1 : turn <= 6 ? turnPrizes[turn] : 16
  }
)

export const getDebatePrizeCoins = createSelector([getPlayerData], ({ turn }) =>
  turn <= 6 ? turnPrizes[turn] * 2 : 16 * 2
)
